import { getCombinedId } from 'utils/helpers'
import { getActiveIntegrationLabel } from 'utils/integrations'
import { getPlanName } from 'utils/plans'
import { buildURL } from 'utils/urls'

import {
  selectActualBrandName,
  selectActualCompanyId,
  selectActualCompanyName,
  selectActualIntegrations,
  selectActualIsPartner,
  selectActualLicenses,
  selectActualMailboxEnabled,
  selectActualMailboxLimit,
  selectActualPartnerName,
  selectEnvironment,
  selectRegion,
} from 'containers/App/selectors'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { MAP_INCIDENT_TYPE_TO_NAME } from 'containers/ResolutionCenter/constants'

export const pendoMSPSupportMiddleware = (store) => (next) => (action) => {
  const result = next(action) // reach the reducer first
  if (
    action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS &&
    typeof window.pendo?.initialize === 'function' &&
    window.IRONSCALES.pendoData
  ) {
    const state = store.getState()

    window.IRONSCALES.pendoData.account = {
      id: getCombinedId(
        selectEnvironment(state),
        selectRegion(state),
        selectActualCompanyId(state)
      ),
      company_name: selectActualCompanyName(state),
      integration: getActiveIntegrationLabel(selectActualIntegrations(state)),
      plan: getPlanName(selectActualLicenses(state).plan),
      is_partner: selectActualIsPartner(state),
      brand_name: selectActualBrandName(state),
      partner_name: selectActualPartnerName(state),
      mailbox_limit: selectActualMailboxLimit(state),
      mailbox_enabled: selectActualMailboxEnabled(state),
    }

    window.pendo.updateOptions(window.IRONSCALES.pendoData)
  }
  return result
}

export const pendoAttachIncident = (reportId, reportType) => {
  if (window.pendo && window.pendo.location?.setUrl) {
    window.pendo.location.setUrl(
      buildURL(window.location.href, {
        reportId,
        reportType: MAP_INCIDENT_TYPE_TO_NAME[reportType],
      })
    )
  }
}

export const pendoDetachIncident = () => {
  if (window.pendo && window.pendo.location?.useBrowserUrl) {
    window.pendo.location.useBrowserUrl()
  }
}
